const baseApiUrl = process.env.REACT_APP_IMAGE_BASE_URL;

export function getUrlFromStoragePath(path) {
  return new URL(path, baseApiUrl).href;
  //return (baseApiUrl + path);
}
